module.exports = __webpack_public_path__ + "static/media/whisky.a271646e.jpg";